import styles from "./IPCameraVideoStreaming.module.css";
import { useDispatch, useSelector } from "react-redux";
import IPCameraCard from "./IPCameraCard";
import Footer from "./Footer";
import { useEffect, useRef, useState } from "react";
import IVSPlayer from "./IVSPlayer";
import { setOpenStreamCamera } from "../../../../Redux/Actions/VideoStreamingActions";

const IPCameraVideoStreamingContainer = ({ page, setPage, socket }) => {
  const videoRef = useRef(null);
  const [refArray, setRefArray] = useState([]);
  const playerRef = useRef(null);
  const { videoStreamAvsChannelList } = useSelector(
    (state) => state?.videoStreamData
  );
  const [isStarted, setIsStarted] = useState(false);
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(null);

  useEffect(() => {
    if (videoStreamAvsChannelList.length == 0) {
      setOpenStreamCamera(dispatch, false);
    }
  }, [videoStreamAvsChannelList]);

  return (
    <>
      <IPCameraCard
        videoRef={videoRef}
        setIsStarted={setIsStarted}
        page={page}
        setPage={setPage}
        socket={socket}
      />

      {videoStreamAvsChannelList.length != 0 && (
        <p className="semi-bold fs-24 pl-20 pl-0 mt-15">
          Below, you can watch the live stream from different angles:
        </p>
      )}
      <div className={styles.gridContainer}>
        {videoStreamAvsChannelList?.map((camera) => (
          <IVSPlayer
            key={camera.id}
            camera={camera}
            setRefArray={setRefArray}
            refArray={refArray}
            socket={socket}
            loadingButton={loadingButton}
            setLoadingButton={setLoadingButton}
          />
        ))}
      </div>
      <Footer
        playerRef={playerRef}
        refArray={refArray}
        socket={socket}
        loadingButton={loadingButton}
        setLoadingButton={setLoadingButton}
      />
    </>
  );
};

export default IPCameraVideoStreamingContainer;
